module.exports = __webpack_public_path__ + "img/fb.72b276b8.svg";